import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchFlowOptions } from '@/services/api';

export function useFlowNavigation(flowId) {
    const [pageTitle, setPageTitle] = useState('');
    const [flowOptions, setFlowOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [flowHistory, setFlowHistory] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        // Reset loading state when flowId changes
        setIsLoading(true);
        setError(null);

        const getFlowOptions = async () => {
            try {
                const data = await fetchFlowOptions(flowId);
                setPageTitle(data.title);
                setFlowOptions(data.options);
            } catch (err) {
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        };

        getFlowOptions();
    }, [flowId]); // Dependencies array includes flowId

    const handleFlowSelection = (option) => {
        if (option.navigationTarget.type === 'route') {
            navigate(option.navigationTarget.value);
        } else if (option.navigationTarget.type === 'flow') {
            // onSetFlow(option.navigationTarget.value)
            navigate(`/flows/${option.navigationTarget.value}`)
        }
    };

    const goBack = () => {
        if (flowHistory.length > 0) {
            const previousFlow = flowHistory[flowHistory.length - 1];
            setFlowHistory(prev => prev.slice(0, -1));
            navigate(`/flows/${previousFlow}`);
        }
    };

    const canGoBack = flowHistory.length > 0;

    return {
        pageTitle,
        flowOptions,
        isLoading,
        error,
        handleFlowSelection,
        goBack,
        canGoBack,
    };
}